// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { IBillAction } from '../../../../../types';
import { isBillStatusPending, isBillStatusPaid, isBillStatusAwaitingDetails } from '../../../utils';
import { BILL_ACTIONS, PRIMARY_ACTIONS_MAPPING_BY_STATUS } from '../../../consts/actions';
import { useStore } from '../../../../../../../store';
import { AVAILABLE_BILL_MODALS } from '../../../components/BillsModalsHub/consts';
import { VIEWS_MAP } from '../../../../../../../router/constants';
import { trackMixPanel } from '../../../../../../../services/mixpanel.service';
import { BILLS_STATUSES } from '../../../../../consts';

const PrimaryBillActions = ({ status, billId } : { status: string, billId: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedBill = useStore(state => state.selectedBill);
  const setShowBillDetailsModal = useStore(state => state.setShowBillDetailsModal);
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const buttonsList = useMemo(() => {
    if (isBillStatusPending(status)) return PRIMARY_ACTIONS_MAPPING_BY_STATUS.PENDING;
    if (isBillStatusPaid(status)) return PRIMARY_ACTIONS_MAPPING_BY_STATUS.PAID;
    if (isBillStatusAwaitingDetails(status)) return PRIMARY_ACTIONS_MAPPING_BY_STATUS.WAITING_DETAILS;
    return null;
  }, [status]);
  const handleOnClick = (name: string) => {
    if (name === BILL_ACTIONS.MARK_AS_PAID && selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) {
      trackMixPanel('Act on specific bill preview - pending', { Action: 'mark as paid' });
    }
    if (name === BILL_ACTIONS.MARK_AS_UNPAID && selectedBill?.calculatedStatus === BILLS_STATUSES.PAID) {
      trackMixPanel('Act on specific bill preview - paid', { Action: 'mark as unpaid' });
    }
    if (name === BILL_ACTIONS.DUPLICATE && selectedBill?.calculatedStatus === BILLS_STATUSES.PAID) {
      trackMixPanel('Act on specific bill preview - paid', { Action: 'Duplicate' });
    }
    if (name === BILL_ACTIONS.DUPLICATE && selectedBill?.calculatedStatus === BILLS_STATUSES.AWAITING_DETAILS) {
      trackMixPanel('Act on specific bill preview - awaiting details', { Action: 'Duplicate' });
    }
    if (name === BILL_ACTIONS.DUPLICATE && selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) {
      trackMixPanel('Act on specific bill preview - pending', { Action: 'duplicate' });
    }
    if (name === BILL_ACTIONS.MARK_AS_PAID) setActiveBillModal(AVAILABLE_BILL_MODALS.MARK_AS_PAID);
    if (name === BILL_ACTIONS.MARK_AS_UNPAID) setActiveBillModal(AVAILABLE_BILL_MODALS.MARK_AS_UNPAID);
    if (name === BILL_ACTIONS.DUPLICATE) {
      setShowBillDetailsModal(false);
      navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.CREATE_BILL.BASE}`, { state: { billId, billStatus: status } });
    }
    if (name === BILL_ACTIONS.PAY_NOW) {
      trackMixPanel('Act on specific bill preview - pending', { Action: 'pay' });
      navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.PAY_BILL.BASE}/${billId}`);
    }
    if (name === BILL_ACTIONS.CANCEL_DETAILS_REQUEST) {
      trackMixPanel('Act on specific bill preview - Awaiting Details', { Action: 'Cancel Payment Request' });
      setActiveBillModal(AVAILABLE_BILL_MODALS.CANCEL_DETAILS_REQUEST);
    }
  };
  if (!buttonsList) return null;
  const createButton = (buttonProps: IBillAction, index: number, isPrimary: boolean) => (
    <div key={buttonProps.key}>
      <LiliButton
        id={`bills_page_main_action_${buttonProps.key}`}
        title={t(buttonProps.title)}
        className={`h-[40px] ${buttonProps?.width ? buttonProps?.width : 'w-[164px]'} ${index === 0 ? 'mr-[12px]' : ''}`}
        icon={<img src={buttonProps.SVGIcon} alt='' />}
        onClick={() => handleOnClick(buttonProps.name)}
        type={isPrimary ? LiliButtonType.PRIMARY : LiliButtonType.SECONDARY}
      />
    </div>
  );
  const buttons = buttonsList.map((button: IBillAction, index: number) => {
    const isPrimary = index === 0;
    return createButton(button, index, isPrimary);
  });
  return (
    <div className='flex'>
      {buttons}
    </div>
  );
};

export default PrimaryBillActions;
